import { ApiService } from "./ApiService.js";
import { ServiceConsts } from "./ServiceConsts.js";

export class TagService {
    static async getTenantTags(tenantId, tagStart) {
        return tagStart
            ? ApiService.get(
                  `${ServiceConsts.API_URL}/tenants/${tenantId}/tags`,
                  `tag=${encodeURIComponent(tagStart)}`,
              )
            : ApiService.get(
                  `${ServiceConsts.API_URL}/tenants/${tenantId}/tags`,
              );
    }

    static async createTenantTag(tenantId, tag) {
        return ApiService.post(
            `${ServiceConsts.API_URL}/tenants/${tenantId}/tags`,
            tag,
        );
    }

    static async renameTenantTag(tenantId, tagId, newTagName) {
        const requestBody = { name: newTagName };
        return ApiService.patch(
            `${ServiceConsts.API_URL}/tenants/${tenantId}/tags/${tagId}`,
            requestBody,
        );
    }

    static async deleteTenantTag(tenantId, tagId) {
        return ApiService.delete(
            `${ServiceConsts.API_URL}/tenants/${tenantId}/tags/${tagId}`,
        );
    }

    static async getNumberOfSnippetsWithTag(tenantId, tagId) {
        return await ApiService.get(
            `${ServiceConsts.API_URL}/tenants/${tenantId}/tags/count?tagId=${encodeURIComponent(tagId)}`,
        );
    }

    /**
     * Returns an array of tag names from the comment input value.
     */
    static getTagNames(commentInputValue) {
        const domParser = new DOMParser();
        const docElement = domParser.parseFromString(
            commentInputValue,
            "text/html",
        ).documentElement;
        let tagNames = [];
        let presentTags = docElement.getElementsByTagName("cw-tag");
        for (let tag of presentTags) tagNames.push(tag.getAttribute("name"));

        return tagNames;
    }
}
